<template>
  <div>
    <span>{{ $t('massBalance.modalStep.selectFlowmeterType') }}</span>
    <div class="reportStyle">
      <VCheckbox
        v-for="(flowmeterType, index) in initialFlowmeterType"
        :key="index"
        v-model="selectedType"
        :rules="[v => v && v.length > 0]"
        :value="flowmeterType"
        :label="$t(`massBalance.modalStep.${flowmeterType === TYPE_STEAM.toLowerCase() ? BOILER.toLowerCase() : flowmeterType}`)"
        @change="emitChange"
      />
    </div>
    <div
      v-for="(flowmeterType, index) in initialFlowmeterType"
      :key="index"
      class="flowMeterType"
    >
      <!--      if checked flowmeterType-->
      <div v-if="selectedType.includes(flowmeterType)">
        <div
          class="d-flex align-center mLeft"
          @click="showData(flowmeterType)"
        >
          <v-icon
            v-if="show[flowmeterType]"
            large
            color="primary"
          >
            mdi-menu-down
          </v-icon>
          <v-icon
            v-else
            large
            color="primary"
          >
            mdi-menu-right
          </v-icon>
          <span>{{
            $t(`massBalance.modalStep.${flowmeterType === TYPE_STEAM.toLowerCase() ? BOILER.toLowerCase() : flowmeterType}`)
          }}</span>
        </div>
        <div :class="{hide: !show[flowmeterType]}">
          <div
            v-for="(floData, floDataIndex) in data[flowmeterType]"
            :key="floDataIndex"
          >
            <VSelect
              v-model="floData.networkId"
              :rules="{ required: true }"
              :label="$t('massBalance.modalStep.network')"
              :items="getAvailableNetworks(flowmeterType, floData.networkId)"
              itemText="name"
              itemValue="id"
              outlined
              @input="debouncedNetworkInput(floData.networkId, flowmeterType)"
              @change="emitChange"
            />
            <VAutocomplete
              v-model="floData.flowmeterIds"
              :label="$t('massBalance.modalStep.flowmeter')"
              :items="listFlowMeterByNetwork[flowmeterType][floData.networkId]"
              outlined
              :multiple="true"
              :rules="{ required: true }"
              @input="onInput"
              @change="emitChange"
            />
            <div
              v-if="data[flowmeterType].length > 1"
              class="delStyleContent"
              @click="removeReportData(flowmeterType, floDataIndex)"
            >
              <div class="delStyleContentDel">
                <v-icon
                  color="white"
                  size="20"
                >
                  delete
                </v-icon>
              </div>
              <div>
                {{ $t('massBalance.delete') }}
              </div>
            </div>
            <div class="actionStyle">
              <div
                class="subBarre"
              />
              <div
                v-if="floDataIndex === data[flowmeterType].length - 1"
                class="addStyle"
                @click="addReportData(flowmeterType)"
              >
                <div class="addStyleContent">
                  <v-icon
                    color="white"
                    size="20"
                  >
                    add
                  </v-icon>
                </div>
                <div>
                  {{ $t('massBalance.add') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';
import VAutocomplete from '@/components/shared/widgets/forms/VuetifyInputs/VAutocomplete.vue';
import { cloneDeep, debounce, isEmpty } from 'lodash';
import { TYPE_STEAM } from '@/aquassist-shared/constants/types/flowMeters';
import { STEAM } from '@/aquassist-shared/constants/types/network';
import { BOILER } from '../../../../aquassist-shared/constants/types/components';

export default {
    name: 'FlowmetersForm',
    components: {
        VAutocomplete,
        VSelect,
    },
    props: {
        mutableValue: {
            type: Object,
            default: null,
        },
        massBalanceSelected: {
            type: Object,
            default: null,
        },
        selection: {
            type: Array,
            default: () => {},
        },
        massBalanceType: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            modeEdit: false,
            selectedType: [],
            show: {
                makeup: true,
                blowdown: true,
                feedWater: true,
                steam: true,
            },
            data: {},
            listNetwork: {},
            staticNetworks: [],
            listFlowMeterByNetwork: {},
            debouncedNetworkInput: debounce(this.networkInput, 300),
        };
    },
    computed: {
        ...mapGetters([
            'site',
        ]),
        TYPE_STEAM() {
            return TYPE_STEAM;
        },
        BOILER() {
            return BOILER;
        },
        initialFlowmeterType() {
            return this.massBalanceType === STEAM ? this.selection.slice(0, -1) : this.selection;
        },
    },
    watch: {
        selectedType() {
            return this.onInput();
        },
    },
    async created() {
        await this.initFlowMeterStep();
    },
    mounted() {
        this.onInput();
        this.emitChange();
    },
    methods: {
        ...mapActions({
            setFlowmeterNetwork: 'setFlowmeterNetwork',
        }),
        async initFlowMeterStep() {
            this.modeEdit = !isEmpty(this.massBalanceSelected);
            this.initialFlowmeterType.forEach(flowmeterType => {
                let config = [
                    {
                        networkId: '',
                        flowmeterIds: [],
                    },
                ];
                if (this.modeEdit) {
                    const flowMeter = this.massBalanceSelected.flowmeters.find(flowmeter => flowmeter.type.toLowerCase() === flowmeterType);
                    if (flowMeter) {
                        config = flowMeter.config;
                        config.forEach(c => {
                            this.networkInput(c.networkId, flowmeterType);
                        });
                        this.selectedType.push(flowmeterType);
                        this.show[flowmeterType] = true;
                    }
                }
                this.data[flowmeterType] = cloneDeep(config);
                this.listNetwork[flowmeterType] = [];
                this.listFlowMeterByNetwork[flowmeterType] = {};
            });
            await this.getNetworkBySite();
        },
        getAvailableNetworks(flowmeterType, networkId) {
            const selectedNetworks = this.data[flowmeterType].map(s => s.networkId);
            const availableNetworks = this.listNetwork[flowmeterType].filter(s => !selectedNetworks.includes(s.id));
            const selectedNetwork = this.listNetwork[flowmeterType].find(s => s.id === networkId);
            if (networkId) {
                availableNetworks.push(selectedNetwork);
            }
            return availableNetworks;
        },
        async getNetworkBySite() {
            const { data } = await this.$rq.getAllSiteNetwork(this.site.id, this.massBalanceType.toLowerCase());
            const networks = data.map(network => ({
                name: network.name,
                id: network.id,
            }));
            this.staticNetworks = networks;
            this.initialFlowmeterType.forEach(flowmeterType => {
                this.listNetwork = {
                    ...this.listNetwork,
                    [flowmeterType]: networks,
                };
            });
            this.onInput();
            this.emitChange();
        },
        showData(flowmeterType) {
            this.show = {
                ...this.show,
                [flowmeterType]: !this.show[flowmeterType],
            };
        },
        addReportData(type) {
            this.data = {
                ...this.data,
                [type]: [...this.data[type], {
                    networkId: '',
                    flowmeterIds: [],
                }],
            };
            this.emitChange();
        },
        removeReportData(type, index) {
            const flows = cloneDeep(this.data[type]);
            flows.splice(index, 1);
            this.data = {
                ...this.data,
                [type]: flows,
            };
            this.emitChange();
        },
        async networkInput(networkId, flowmeterType) {
            const { data } = await this.$rq.getMassBalanceFlowMeterByNetwork(this.site.id, networkId, flowmeterType.toUpperCase());
            this.listFlowMeterByNetwork = {
                ...this.listFlowMeterByNetwork,
                [flowmeterType]: {
                    ...this.listFlowMeterByNetwork[flowmeterType],
                    [networkId]: data.map(flowMeterByNetwork => ({
                        name: flowMeterByNetwork.name,
                        id: flowMeterByNetwork.id,
                    })),
                },
            };
            this.onInput();
        },
        validateFlowMeters() {
            let isValid = this.selectedType.length > 0;
            this.selectedType.forEach(type => {
                this.data[type].forEach(v => {
                    isValid = isValid && !!v.networkId && v.flowmeterIds.length > 0;
                });
            });
            return isValid;
        },
        emitChange() {
            this.$emit('inputChange', this.validateFlowMeters);
        },
        onInput() {
            const data = [];
            const summaryData = [];
            const selectedNetworks = [];
            const allNetworks = this.staticNetworks;
            this.selectedType.forEach(type => {
                data.push({
                    type: type.toUpperCase(),
                    config: this.data[type],
                });
                summaryData.push({
                    type: type.toUpperCase(),
                    config: this.data[type].map(p => {
                        let network = { id: '', name: '' };
                        network = this.listNetwork[type].find(n => n.id === p.networkId) || network;
                        selectedNetworks.push(network);
                        const flowmeters = Object.values(this.listFlowMeterByNetwork[type]).flat().filter(f => p.flowmeterIds.includes(f.id));
                        return { network, flowmeters };
                    }),
                });
            });
            this.setFlowmeterNetwork({ flowMeters: { data, summaryData, selectedNetworks, allNetworks } });
        },
    },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/massBalanceStyle.scss";
</style>
